interface Props {
  size: number;
}

export default function PromineoCircle (props: Props) {
  const { size } = props;
  const style = {
    height: `${size}px`,
    width: `${size}px`
  };
   
  return (
    <div className="rounded-full bg-primaryRed ml-45 inline-block" style={style}></div>
  );
}